import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import QrReader from 'react-qr-reader';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Icon } from 'semantic-ui-react';
import agent from '../../api/agent';
import { useStore } from '../../stores/store';

function QrModal() {
  const { modalStore, activityStore, userStore } = useStore();
  const { loadActivities, activityRegistryAll } = activityStore;
  const [activityResult, setActivityResult] = useState<string>('');
  const history = useNavigate();
  const [camError, setCamError] = useState<boolean>(false);
  const [itemExistId, setItemExistId] = useState('');

  useEffect(() => {
    if (activityRegistryAll.size <= 1) loadActivities();
    // eslint-disable-next-line
  }, []);

  const handleScan = async (data: string | null) => {
    setActivityResult(data || '');
    if (data !== null) {
      let params = {
        userId: userStore.user?.id || '',
        referenceId: data,
      };
      let result = await agent.Activities.itemExistAPI(params);
      if (result?.data) {
        setItemExistId(result.data);
      }
    }
  };

  const handleError = (err: string) => {
    console.error(err);
    setCamError(true);
    setItemExistId('');
  };

  const ScanModal = () => {
    // eslint-disable-next-line
    if (itemExistId?.length) {
      history(`/mediaAssets/${itemExistId}`);
      modalStore.closeSmallModal();
    } else {
      toast.info('Oops! sorry we cannot find the item');
      setActivityResult('');
    }
    setItemExistId('');
  };

  return (
    <div>
      <>
        {activityResult.length !== 0 ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <Icon name="check" size="big" color="green" />
            <p
              style={{
                color: '#6c6c6c',
                fontSize: '18px',
                fontWeight: 600,
              }}
            >
              Item scanned successfully.
              <p>Kindly proceed with the search now.</p>
            </p>
          </div>
        ) : camError ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <Icon name="ban" size="big" color="red" />
            <p
              style={{
                color: '#6c6c6c',
                fontSize: '18px',
                fontWeight: 600,
              }}
            >
              Camera not accessible.
            </p>
          </div>
        ) : (
          <QrReader
            delay={300}
            onError={handleError}
            onScan={handleScan}
            style={{ width: '100%' }}
            facingMode="environment"
          />
        )}
        <Button.Group
          floated="right"
          attached="bottom"
          className="mobile-qr-cancel-save"
          style={{ marginTop: '15px', marginBottom: '15px' }}
        >
          <Button
            onClick={() => {
              modalStore?.closeSmallModal();
              setItemExistId('');
            }}
            type="reset"
          >
            Cancel
          </Button>
          <Button.Or />
          <Button
            disabled={!activityResult?.length}
            onClick={ScanModal}
            positive
            type="submit"
          >
            Search
          </Button>
        </Button.Group>
      </>
    </div>
  );
}

export default observer(QrModal);
